import FieldControl from 'components/form/validator/controls/FieldControl';

/**
 * Directive to handle v-form-control fields, basically a wrapper around FieldControl
 *
 * Directive defined in index.js as part of the plugin.
 */
export default {
    inserted(el, bindings, vnode) {
        // On insert register field control register, do first validation
        el.__fieldCtrl = (new FieldControl(el, bindings, vnode)).register();
    },
    update(el, bindings) {
        if (typeof bindings.value === 'undefined') {
            bindings.value = {};
        }

        // When updated change updated bindings
        el.__fieldCtrl.updateBindings(bindings);
        // Update any change attrs
        el.__fieldCtrl.updateItemChangeOnEl(el);
        // Trigger update event
        el.__fieldCtrl.eventHandler('update')();
    },
    unbind(el) {
        // Remove all listeners and triggers
        el.__fieldCtrl.unregister();
    },
};



// WEBPACK FOOTER //
// ./src/components/form/validator/directive.js